export default {"src":"/_next/static/media/cvc.a6121792.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};